<script setup lang="ts">
import { Stack, Typography } from '@apparatix/library/core';
</script>
<template>
  <Stack :gap="4" class="overflow-y-auto max-h-[60vh]">
    <Typography variant="body">
      This AI&ndash;powered tool is intended to support your client relationships by providing helpful suggestions, insights, and ideas for out&ndash;of&ndash;home advertising.
    </Typography>
    <Typography variant="body">
      By using this AI&ndash;powered tool (&ldquo;Tool&rdquo;), you acknowledge and agree to the following:
    </Typography>
    <Stack :gap="2">
      <Typography variant="section-subheading">
        Experimental Feature
      </Typography>
      <Typography variant="body" indent>
        The Tool is provided &ldquo;as is,&rdquo; without any guarantee of accuracy or completeness. Occasional errors, omissions, or misunderstandings may occur.
      </Typography>
    </Stack>
    <Stack :gap="2">
      <Typography variant="section-subheading">
        User Responsibility
      </Typography>
      <Typography variant="body" indent>
        You are solely responsible for verifying and applying any suggestions or insights the Tool provides.
      </Typography>
    </Stack>
    <Stack :gap="2">
      <Typography variant="section-subheading">
        Additional Charges
      </Typography>
      <Typography variant="body" indent>
        Certain AI&ndash;powered features may incur additional fees. You will be notified of any applicable charges, and continued use constitutes your acceptance of these fees.
      </Typography>
    </Stack>
    <Stack :gap="2">
      <Typography variant="section-subheading">
        Modifications
      </Typography>
      <Typography variant="body" indent>
        We reserve the right to modify, suspend, or discontinue the Tool at any time, and to update this disclaimer. Continued use after any changes signifies acceptance of the revised disclaimer.
      </Typography>
    </Stack>
  </Stack>
</template>
